import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useEffect } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { getMyMembers } from 'service/CollectiveService'
import { setMyMembers } from 'store/slices/CollectiveSlice'
const EmployeeSelectUserId = ({
  selectedEmployee,
  setSelectedEmployeeLabel,
  service,
  isMulti,
}) => {
  const dispatch = useDispatch()
  const [isLoading, setLoading] = useState(true)

  const getData = async () => {
    try {
      let response = await getMyMembers(service ,data)

      dispatch(
        setMyMembers({
          members: response.data,
        }),
      )
    } catch (error) {
      console.log("CHU")
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const myTeam = useSelector((state) => state.collective.members)
  const confirmedEmployees = myTeam ? [myTeam.confirmed] : []
  const data = [confirmedEmployees.flat().filter((item) => item.flag)]

  const animatedComponents = makeAnimated()
  const handleSelect = (dataEmployees) => {
    isMulti
      ? selectedEmployee(dataEmployees.map((employee) => employee.value))
      : selectedEmployee(dataEmployees.value)
    isMulti
      ? setSelectedEmployeeLabel(
          dataEmployees.map((employee) => employee.value),
        )
      : setSelectedEmployeeLabel(dataEmployees.value)
  }
  useEffect(() => {
    if (data?.length !== 0) {
      setLoading(false)
    }
  }, [data])
  const selectInfoStyles = {
    width: '100%', 
    zIndex: 9999, 
    maxWidth: '100vh', 
    minWidth: '100vh', 
  };


  const mobileStyles = {
    maxWidth: '100%',
    minWidth: '100%', 
  };

  return (
    <div style={{ ...selectInfoStyles, ...mobileStyles }}>
      <Select
        closeMenuOnSelect={true}
        components={animatedComponents}
        options={data[0]}
        onChange={handleSelect}
        isSearchable={true}
        placeholder="Выбрать сотрудника"
        autosize={true}
        isMulti={isMulti ? true : false}
        noOptionsMessage={() => 'Поиск не дал результатов'}
        isLoading={isLoading}
      />
    </div>
  )
}

export default EmployeeSelectUserId
